export class BulkSensorsTransactionRow{
  mac?: string
  result?: boolean
  type?: string
  status?: string

  constructor(params?: Partial<BulkSensorsTransactionRow>) {
    Object.assign(this, params)
  }
}
